import { Icon } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";

const IconButton = styled(Icon).attrs()`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  &:hover {
    background-color: ${(props) => props.theme.palette.light.c200} !important;
  }
  ${props => props.disabled &&`
    cursor: not-allowed;
    opacity: .5;
    pointer-events: none;
    &:hover {
      background-color: unset !important;
    }
  `}
`;

export default IconButton;
